/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Freiherr_Vom_Stein_Schule_Fulda4Inputs */

const en__field_enum_freiherr_vom_stein_schule_fulda4 = /** @type {(inputs: _Field_Enum_Freiherr_Vom_Stein_Schule_Fulda4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fulda`)
};

const de__field_enum_freiherr_vom_stein_schule_fulda4 = /** @type {(inputs: _Field_Enum_Freiherr_Vom_Stein_Schule_Fulda4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freiherr-vom-Stein-Schule`)
};

/**
* | output |
* | --- |
* | "Fulda" |
*
* @param {_Field_Enum_Freiherr_Vom_Stein_Schule_Fulda4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_freiherr_vom_stein_schule_fulda4 = /** @type {((inputs?: _Field_Enum_Freiherr_Vom_Stein_Schule_Fulda4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Freiherr_Vom_Stein_Schule_Fulda4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_freiherr_vom_stein_schule_fulda4(inputs)
	return de__field_enum_freiherr_vom_stein_schule_fulda4(inputs)
});
export { _field_enum_freiherr_vom_stein_schule_fulda4 as "_field_enum_Freiherr_vom_Stein_Schule_Fulda" }